import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  isPatient,
  isPractice,
  isAgencyDoctor,
  isAdmin,
  agencyDoctorWithRPMAndCCMRoles,
  isRoleNameAdministrator,
} from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import { generateFullName } from 'utils/badgeHelpers';
import MenuHeader from './menuHeader';
import MenuItemDropDown from './menuItemDropdown';
import {
  MenuItemProfile,
  MenuItemPlatform,
  MenuItemTelemed,
  MenuItemFiles,
  MenuItemAmazonConnect,
  MenuItemLogout,
} from './items';

const Menu = ({
  closeMenu,
  swiched,
  practiceOptions,
  patientsOptions,
  formsOptions,
  adminPanelOptions,
  limitedMenu,
}) => {
  const { userType, firstName, lastName, title, roleNames } = useUser();
  const hasAccessToAdminPanel =
    isRoleNameAdministrator(roleNames) || isAdmin(userType);

  return (
    <nav
      className={classNames('menu', 'menu__container', {
        'menu--active': swiched,
      })}
    >
      <MenuHeader closeMenu={closeMenu} />
      <ul className="menu__list">
        {!isPatient(userType) && (
          <>
            <MenuItemProfile
              name={generateFullName(title, firstName, null, lastName)}
              onClick={closeMenu}
            />
            <div className="menu-item-icon-spacer" />
            {(isPractice(userType) ||
              isAdmin(userType) ||
              agencyDoctorWithRPMAndCCMRoles(userType, roleNames)) &&
              !limitedMenu && (
                <>
                  <MenuItemPlatform onClick={closeMenu} />
                  <div className="menu-item-icon-spacer" />
                </>
              )}
            {!isPatient(userType) && !limitedMenu && (
              <>
                <MenuItemTelemed onClick={closeMenu} />
                <div className="menu-item-icon-spacer" />

                <MenuItemFiles onClick={closeMenu} />
                <div className="menu-item-icon-spacer" />
              </>
            )}
            {(isAdmin(userType) || isAgencyDoctor(userType)) && !limitedMenu && (
              <>
                <MenuItemAmazonConnect onClick={closeMenu} />
                <div className="menu__spacer" />
              </>
            )}

            {!limitedMenu && (
              <li>
                <MenuItemDropDown
                  label="Forms"
                  onClick={closeMenu}
                  options={formsOptions}
                />
                <div className="menu__spacer" />
              </li>
            )}
            {adminPanelOptions.length > 0 &&
              hasAccessToAdminPanel &&
              !limitedMenu && (
                <li>
                  <MenuItemDropDown
                    label="Admin Panel"
                    onClick={closeMenu}
                    options={adminPanelOptions}
                  />
                  <div className="menu__spacer" />
                </li>
              )}
            {practiceOptions.length > 0 && !limitedMenu && (
              <li>
                <MenuItemDropDown
                  label="Practice"
                  onClick={closeMenu}
                  options={practiceOptions}
                />
                <div className="menu__spacer" />
              </li>
            )}
            {patientsOptions.length > 0 && !limitedMenu && (
              <li>
                <MenuItemDropDown
                  label="Patients"
                  onClick={closeMenu}
                  options={patientsOptions}
                />
                <div className="menu__spacer" />
              </li>
            )}
          </>
        )}
        <MenuItemLogout />
      </ul>
    </nav>
  );
};

Menu.propTypes = {
  swiched: PropTypes.bool,
  closeMenu: PropTypes.func,
  practiceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  patientsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  formsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  adminPanelOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  limitedMenu: PropTypes.bool,
};

export default Menu;
